import { IntlShape } from "react-intl";

const getListViewTourSteps = (intl: IntlShape) => [
  {
    target: "body",
    content: intl.formatMessage({
      id: "components.tour.listview.welcome",
      defaultMessage:
        "Welcome to the list view! There are a few features we'd like to highlight so that you are able to make optimal use of this view.",
    }),
    placement: "center",
  },
  {
    target: ".search-container-expandable",
    content: intl.formatMessage({
      id: "components.tour.listview.search",
      defaultMessage: "You can search for specific records by clicking the search icon here and typing in the search bar.",
    }),
  },
  {
    target: ".tab-container",
    content: intl.formatMessage({
      id: "components.tour.listview.tabs",
      defaultMessage: "You can filter the records by status by clicking on the tabs here.",
    }),
  },
  {
    target: ".table-sort-icon",
    content: intl.formatMessage({
      id: "components.tour.listview.sort",
      defaultMessage: "Some table headers are sortable (ASC/DESC) and can be done so by clicking on the sort icon.",
    }),
  },
  {
    target: ".sortable",
    content: intl.formatMessage({
      id: "components.tour.listview.drag",
      defaultMessage:
        "You can change the order of the columns by dragging. Try hovering the mouse over the column header and you'll see the drag icon appear.",
    }),
    spotlightClicks: true,
  },
  {
    target: ".filter-container",
    content: intl.formatMessage({
      id: "components.tour.listview.filter",
      defaultMessage:
        "You can filter table data by clicking on the filter icon. If you want to reuse a set of filters often, you can save them as a preset.",
    }),
  },
  {
    target: ".column-filter",
    content: intl.formatMessage({
      id: "components.tour.listview.columns",
      defaultMessage: "You can choose which table columns to display by clicking on the column filter icon.",
    }),
  },
  {
    target: ".menu-icon",
    content: intl.formatMessage({
      id: "components.tour.listview.actions",
      defaultMessage:
        "Some records will have actions that can be performed on them. These actions will be shown here whilst hovering the record.",
    }),
  },
  {
    target: "body",
    content: intl.formatMessage({
      id: "components.tour.listview.finish",
      defaultMessage:
        "These are the main features of the list view. Remember, you can restart the tour at anytime from the settings page.",
    }),
    placement: "center",
  },
];

export default getListViewTourSteps;
